import { SpinnerCircularFixed } from "spinners-react";

const SALoader = ({
  size = 35,
  thickness = 300,
  color = "#31360b",
  secondaryColor = "#CFCFCF",
  ...rest
}) => {
  return (
    <SpinnerCircularFixed
      {...{
        size,
        color,
        thickness,
        secondaryColor,
        ...rest,
      }}
    />
  );
};

export default SALoader;
